
import { Player, Scenario } from '@/models';
import { computed, defineComponent, ref, watch } from 'vue';
import ScenarioScreen from '../Facilitator/screens/Scenario.vue';
import PlayerList from '../Facilitator/components/PlayerList.vue';
import OptionsPanel from './components/OptionsPanel.vue';

const DEFAULT_PLAYER_COUNT = 20;
const DEFAULT_SCENARIO_TEXT = `Your best friend has just been hurt badly. You're the only one who knows who did it. Right before it happens they confide in you about a disagreement they had with the person who hurt them. Your best friends' family and other friends are outraged and planning revenge.  You know something bad will happen if you reveal who did it. How do you handle the situation?`;

function makeid(length: number) {
	let result = '';
	const characters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	let counter = 0;
	while (counter < length) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
		counter += 1;
	}
	return result;
}

const colors = ['#FF6969', '#44AACF', '#D5F560', '#FFB341', '#B865CF'];

let nextPlayerId = 1;

function generatePlayer(): Player {
	const nameLength = 1 + Math.floor(Math.random() * 19);
	return {
		id: nextPlayerId++,
		name: makeid(nameLength),
		avatarBackgroundColor: colors[Math.floor(Math.random() * colors.length)],
		avatarImageUrl: '/avatars/avatar-generic.svg',
		score: Math.floor(Math.random() * 10),
		handRaised: false,
		questionAnswered: false,
		remainingSkips: 3
	};
}

function generatePlayers(count: number): Player[] {
	return Array.from({ length: count }, () => generatePlayer());
}

export default defineComponent({
	components: {
		ScenarioScreen,
		PlayerList,
		OptionsPanel
	},
	setup() {
		const playerCount = ref(DEFAULT_PLAYER_COUNT);
		const scenarioText = ref(DEFAULT_SCENARIO_TEXT);

		const players = ref(generatePlayers(DEFAULT_PLAYER_COUNT));

		watch(playerCount, count => {
			const current = players.value;
			if (count < current.length) {
				players.value = current.slice(0, count);
			} else {
				for (let i = current.length; i < count; i++) {
					current.push(generatePlayer());
				}
			}
		});

		const scenario = computed<Scenario>(() => ({
			id: 1,
			text: scenarioText.value,
			category: {
				id: 1,
				title: 'Test Category',
				imageUrl:
					'https://on-the-edge-contentbucket-1l8x08167uqei.s3.amazonaws.com/which-way-is-out.png',
				description: '',
				ordinal: 1
			}
		}));

		return { scenario, players, playerCount, scenarioText };
	}
});
